import React, { memo, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import { useELDIntegration, useFMSAnalytics } from 'apps/fleet-planner/hooks'
import {
  KeepTruckinGrantUrl,
  KeepTruckinGrantUrlResponse,
  TIntegrationType,
} from 'apps/fleet-planner/types'
import { EldProviderList } from '../EldProviderList'
import { EldIntegrationStepContainer } from './EldIntegrationStepContainer'

/**
 * Step 1 of 2: "Choose your ELD provider"
 */
export const EldIntegrationStepConnect = memo(() => {
  const { trackEvent } = useFMSAnalytics()
  const [selectedOption, setSelectedOption] = useState<TIntegrationType>('keepTruckin')
  const { params } = useELDIntegration()
  const { carrierId: motorCarrierId } = params || {}

  /**
   * Generates onClick function
   */
  const createClickHandler = (res: KeepTruckinGrantUrlResponse | null) => {
    return () => {
      trackEvent('ELD', 'CLICKED_CONTINUE_ELD_PROVIDER_BUTTON')
      const { grantUrl } = res ?? {}
      // open url in the same tab to avoid redirection issues with KT
      if (grantUrl) window.location.replace(grantUrl)
    }
  }

  return (
    <EldIntegrationStepContainer
      title='Connect your ELD provider'
      pageText='Step 1 of 2'
      maxWidth={950}>
      <Box mb={4.5}>
        <EldProviderList onChange={setSelectedOption} value={selectedOption} />
      </Box>
      {selectedOption === 'keepTruckin' && (
        <Box textAlign='right' mr={2}>
          <KeepTruckinGrantUrl debounce={200} queryParams={{ motorCarrierId }}>
            {(data, { loading }) => (
              <Button
                color='primary'
                size='large'
                disabled={loading}
                onClick={createClickHandler(data)}
                data-test='button-connect'>
                Continue
              </Button>
            )}
          </KeepTruckinGrantUrl>
        </Box>
      )}
    </EldIntegrationStepContainer>
  )
})
